
import { throwError as observableThrowError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class MessageUploadService {
    srvUrl: string;
    constructor(private http: Http) {
        this.srvUrl = `${environment.api.msgUrl}`;
     }
    
   serviceCall(data: string) {
        let url = this.srvUrl;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.set('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options)
            .pipe(catchError(this.handleError))
    }


    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }   
}
